import { memo, useCallback, useEffect, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryResultsPage.module.scss";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { ISociometrySessionResult, SociometrySessionStatus } from "shared/types/sociometry";
import { SociometryMutualPairsList, SociometryResultsTable } from "components/sociometry";
import { Layout } from "components/Layout";
import { BackButton } from "components/BackButton";

interface SociometryResultsPageProps {
    className?: string;
}

export const SociometryResultsPage = memo((props: SociometryResultsPageProps) => {
    const { className } = props;
    const history = useHistory();
    const { id: sessionId } = useParams<{ id: string }>();
    const [sessionResult, setSessionResult] = useState<ISociometrySessionResult | null>(null);

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            try {
                const { data } = await axios.get(`sociometry/psych/session/${sessionId}/result`);
                if (isMounted) {
                    setSessionResult(data);
                }
            } catch (e) {
                console.error(e);
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [sessionId]);

    const statusMap: Record<SociometrySessionStatus, string> = {
        Pending: "Назначено",
        Active: "В процессе",
        Completed: "Завершено",
    };

    const onClickPupil = useCallback(
        (pupilId: string) => {
            history.push(`/sociometry/results/${sessionId}/pupil/${pupilId}`);
        },
        [history, sessionId],
    );

    return (
        <Layout>
            <div className={classNames(cls.sociometryResultsPage, {}, [className])}>
                <header className={cls.header}>
                    <BackButton />
                    <p className={cls.title}>Социометрия</p>
                </header>
                <div className={cls.classUnit}>
                    <p>
                        {sessionResult?.class.number}
                        {sessionResult?.class?.letter}
                    </p>
                </div>
                <div className={cls.content}>
                    <div className={cls.sectionTitle}>
                        <p>Результаты сессии</p>
                    </div>
                    <div>
                        <p className={cls.info}>
                            Статус: <span>{statusMap[sessionResult?.status || "Pending"]}</span>
                        </p>
                        <p className={cls.info}>
                            Прошли тест: <span>{sessionResult?.completionRate || "0%"}</span>
                        </p>
                    </div>

                    <SociometryResultsTable scores={sessionResult?.scores || []} onClickRow={onClickPupil} />
                    <div className={cls.mutualPairsSection}>
                        <div className={cls.sectionTitle}>Взаимные пары</div>
                        <SociometryMutualPairsList pairs={sessionResult?.mutualPairs || []} />
                    </div>
                </div>
            </div>
        </Layout>
    );
});

SociometryResultsPage.displayName = "SociometryResultsPage";
